<template>
  <div class="flex size-full">
    <div ref="mapContainerElement" class="size-full"></div>
    <template v-if="!!mapsLoader && !!map">
      <slot :maps-loader="mapsLoader" :map="map" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { Loader } from '@googlemaps/js-api-loader'

type MapOptions = google.maps.MapOptions
type Map = google.maps.Map

const props = defineProps({
  mapOptions: {
    type: Object as PropType<MapOptions>,
    default: () => ({}),
  },
  apiKey: {
    type: String as PropType<string>,
    default: '',
  },
})

const mapContainerElement = ref()
const mapsLoader = ref<Loader>()
const map = ref<Map>()

onMounted(async () => {
  const loader = new Loader({
    apiKey: props.apiKey,
  })

  mapsLoader.value = loader

  const { Map } = (await loader.importLibrary(
    'maps',
  )) as google.maps.MapsLibrary

  map.value = new Map(
    mapContainerElement.value as HTMLElement,
    props.mapOptions,
  )
})
</script>
